import { PartType } from '../constants/part-type.js';
import { isStockablePartType } from './is-stockable-part-type.js';
/** Every stockable part type, derived from `isStockablePartType` so it and `NON_STOCKABLE_PART_TYPE_IDS` partition `PartType` exactly. */
export const STOCKABLE_PART_TYPE_IDS = Object.values(PartType)
    .filter((value) => typeof value === 'number')
    .filter((typeId) => isStockablePartType(typeId));
//# sourceMappingURL=stockable-part-type-ids.js.map